import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Component Imports
import Loading from "../../../Components/Interactive/Loading";
import LatestOrdersTable from "./LatestOrders/LatestOrdersTable";

// Redux Imports
import { getOrders } from "../../../Redux/Actions/orderActions";
import { logout } from "../../../Redux/Actions/userActions";

// Import MUI
import RefreshIcon from '@mui/icons-material/Refresh';

//CSS Imports
import "./HomeStyles.css";

const Home = ({ isOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const orders = useSelector(({ orders }) => orders);

  useEffect(() => {
    (async () => {
      const res = await fetch(`/api/auth/get-auth`, {
        credentials: "include",
      });
      if (res.status === 401) {
        dispatch(logout());
        return navigate("/");
      } else {
        dispatch(getOrders(navigate));
      }
    })();
    if(localStorage.getItem('previousSearchResults')) localStorage.removeItem('previousSearchResults')
  }, [dispatch, navigate]);

  return (
    <div className={`${isOpen ? "page" : "page-closed"}`}>
      <h3 className="heading">Latest Orders
        
      <button
          style={{ marginLeft: '10px', width: '25px', height: '20px' }}
          className="add-note-btn-open"
          onClick={(e) => dispatch(getOrders(navigate))}
        >
          <span><RefreshIcon fontSize='small' sx={{ color: 'fff !important', marginBottom: '-5px' }} /></span>
      </button>

      </h3>
      {orders && orders.loading && <Loading />}
      {orders &&
        orders.orders &&
        orders.orders.result &&
        orders.orders.result.length && (
          <LatestOrdersTable orders={orders.orders.result} />
        )}
    </div>
  );
};

export default Home;
